// extracted by mini-css-extract-plugin
export default {"container":"CodeLanguageControl_container__mFluu","tooltip":"CodeLanguageControl_tooltip__BQJoU"};